{
  "name": "altorney.web",
  "version": "6.0.4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:prod": "node --max_old_space_size=8192 node_modules/@angular/cli/bin/ng build --configuration=production",
    "build:test": "ng build --configuration=test",
    "build:demo": "ng build --configuration=demo",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:watch": "ng test --watch",
    "format": "prettier --write \"src/**/*.{ts,html}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html}\"",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org altorney --project altorney-web ./dist && sentry-cli sourcemaps upload --org altorney --project altorney-web ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.21",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.21",
    "@angular/compiler": "^21.2.21",
    "@angular/core": "^21.2.21",
    "@angular/forms": "^21.2.21",
    "@angular/platform-browser": "^21.2.21",
    "@angular/platform-browser-dynamic": "^21.2.21",
    "@angular/platform-server": "^21.2.21",
    "@angular/router": "^21.2.21",
    "@azure/communication-chat": "^1.6.0",
    "@azure/communication-common": "^2.3.1",
    "@azure/communication-identity": "^1.3.1",
    "@azure/communication-signaling": "^1.0.0-beta.29",
    "@ctrl/ngx-emoji-mart": "^9.2.0",
    "@e965/xlsx": "^0.20.3",
    "@flatfile/api": "^1.23.0",
    "@flatfile/javascript": "^1.2.6",
    "@flatfile/listener": "^1.0.1",
    "@flatfile/plugin-autocast": "^0.7.6",
    "@flatfile/plugin-record-hook": "^1.4.4",
    "@fullcalendar/angular": "^6.1.20",
    "@fullcalendar/core": "^6.1.20",
    "@fullcalendar/daygrid": "^6.1.20",
    "@fullcalendar/interaction": "^6.1.20",
    "@fullcalendar/moment-timezone": "^6.1.20",
    "@fullcalendar/timegrid": "^6.1.20",
    "@microsoft/signalr": "^8.0.7",
    "@ng-select/ng-select": "^21.8.2",
    "@ngneat/bind-query-params": "^6.0.0",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngrx/component-store": "^21.1.0",
    "@ngrx/operators": "^21.1.0",
    "@ngrx/signals": "^21.1.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@primeuix/themes": "^2.0.3",
    "@sentry/angular": "^10.47.0",
    "@sentry/cli": "^2.32.1",
    "@sentry/webpack-plugin": "^5.4.0",
    "@tailwindcss/postcss": "^4.3.3",
    "chart.js": "^4.4.5",
    "chartjs-adapter-moment": "^1.0.1",
    "chartjs-plugin-annotation": "^3.1.0",
    "chartjs-plugin-zoom": "^2.0.1",
    "class-transformer": "^0.5.1",
    "crypto-js": "^4.1.1",
    "csstype": "^3.1.3",
    "file-saver": "^2.0.5",
    "fuse.js": "^7.0.0",
    "jspdf": "^4.2.1",
    "jszip": "^3.10.1",
    "jwt-decode": "^3.1.2",
    "libphonenumber-js": "^1.12.40",
    "lodash": "^4.17.21",
    "lodash-es": "^4.17.21",
    "marked": "^17.0.6",
    "mini-css-extract-plugin": "^2.9.1",
    "moment": "^2.29.4",
    "moment-precise-range-plugin": "^1.3.0",
    "moment-timezone": "^0.5.46",
    "ngx-doc-viewer": "^15.0.1",
    "ngx-google-analytics": "^14.0.1",
    "ngx-infinite-scroll": "^21.0.0",
    "ngx-markdown": "^21.1.0",
    "ngx-mask": "^21.1.0",
    "ngx-quill": "^30.0.1",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.5",
    "pubnub": "^7.6.1",
    "quill-mention": "^6.1.1",
    "quilljs-markdown": "^1.2.0",
    "rxjs": "~7.8.0",
    "tailwindcss-primeui": "^0.6.1",
    "turndown": "^7.1.2",
    "zone.js": "^0.15.1"
  },
  "overrides": {
    "brace-expansion@2": "^2.1.2",
    "esbuild": "^0.28.1",
    "tsup": "^8.3.5",
    "axios": "^1.16.0",
    "basic-ftp": "^5.3.1",
    "vite": "^7.3.5"
  },
  "devDependencies": {
    "@angular/build": "^21.2.21",
    "@angular/cli": "^21.2.21",
    "@angular/compiler-cli": "^21.2.21",
    "@sentry/types": "^8.34.0",
    "@testing-library/angular": "^19.4.1",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/user-event": "^14.6.1",
    "@types/backo2": "^1.0.1",
    "@types/chart.js": "^2.9.37",
    "@types/crypto-js": "^4.0.2",
    "@types/file-saver": "^2.0.7",
    "@types/lodash": "^4.14.180",
    "@types/lodash-es": "^4.17.6",
    "@types/node": "^24.12.2",
    "@types/pubnub": "^7.4.2",
    "@types/quill": "^1.3.10",
    "@types/turndown": "^5.0.4",
    "@typescript-eslint/eslint-plugin": "^8.58.0",
    "@typescript-eslint/parser": "^8.58.0",
    "@vitest/coverage-v8": "^4.1.9",
    "eslint": "^10.2.0",
    "eslint-config-google": "^0.14.0",
    "eslint-config-prettier": "^9.1.0",
    "jsdom": "^29.1.1",
    "parchment": "^3.0.0",
    "postcss": "^8.5.26",
    "prettier": "^3.8.1",
    "tailwindcss": "^4.2.2",
    "tslib": "^2.6.2",
    "typescript": "~5.9.3",
    "typescript-eslint": "0.0.1-alpha.0",
    "vitest": "^4.1.11",
    "webpack-bundle-analyzer": "^4.10.1"
  }
}
